(function ($) {
  'use strict';

  /* ---------- Configuración ---------- */

  // Qué hacer después de agregar: 'cart' redirige a /cart, 'stay' se queda en la página.
  var AFTER_ADD = 'stay';

  // true  -> si algún producto del set está agotado, se bloquea el botón.
  // false -> se agregan solo los disponibles.
  var BLOCK_IF_ANY_UNAVAILABLE = true;

  // Nombre de la property que agrupa las líneas del set.
  // Con "_" al inicio queda oculta en carrito y checkout (sigue visible en el admin).
  var SET_PROPERTY = 'ID SET';

  // Cantidad por producto del set.
  var ITEM_QUANTITY = 1;

  var TEXTS = {
    adding: 'Adding...',
    unavailable: 'Currently unavailable',
    error: 'We could not add the set to your cart. Please try again.',
    success: 'Set added to your cart.'
  };

  /* ---------- Helpers ---------- */

  function isTrue(value) {
    return value === true || value === 'true';
  }

  function collectItems() {
    var items = [];

    $('[data-set-includes] .set-includes__item').each(function () {
      var $item = $(this);
      var id = $item.attr('data-variant-id');

      if (!id) return;

      items.push({
        id: String(id),
        available: isTrue($item.attr('data-available'))
      });
    });

    return items;
  }

  function buildSetId() {
    var letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var numeros = '0123456789';
    var resultado = '';
    var i;

    for (i = 0; i < 2; i++) {
      resultado += letras.charAt(Math.floor(Math.random() * letras.length));
    }

    for (i = 0; i < 3; i++) {
      resultado += numeros.charAt(Math.floor(Math.random() * numeros.length));
    }

    return resultado.split('').sort(function () {
      return 0.5 - Math.random();
    }).join('');
  }

  function setStatus(message, isError) {
    var $status = $('.form-bundle-kit .product-status-message');

    if (!$status.length) return;

    $status
      .text(message || '')
      .toggleClass('product-status-message--error', !!isError);
  }

  /* ---------- Estado inicial ---------- */

  $(function () {
    var $wrapper = $('[data-set-includes]');

    if (!$wrapper.length) return;

    if (BLOCK_IF_ANY_UNAVAILABLE && isTrue($wrapper.attr('data-has-unavailable'))) {
      $('.form-bundle-kit .add-set-to-cart')
        .prop('disabled', true)
        .text(TEXTS.unavailable);
    }
  });

  /* ---------- Add to cart ---------- */

  $(document).on('click', '.form-bundle-kit .add-set-to-cart', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    var $button = $(this);

    if ($button.prop('disabled')) return;

    var items = collectItems();

    if (!items.length) return;

    if (BLOCK_IF_ANY_UNAVAILABLE) {
      var hasUnavailable = items.some(function (item) {
        return !item.available;
      });

      if (hasUnavailable) {
        setStatus(TEXTS.unavailable, true);
        return;
      }
    }

    var setId = buildSetId();
    var properties = {};
    properties[SET_PROPERTY] = setId;

    var payload = items
      .filter(function (item) {
        return item.available;
      })
      .map(function (item) {
        return {
          id: item.id,
          quantity: ITEM_QUANTITY,
          properties: properties
        };
      });

    if (!payload.length) {
      setStatus(TEXTS.unavailable, true);
      return;
    }

    var originalLabel = $button.text();

    $button.prop('disabled', true).addClass('is-loading').text(TEXTS.adding);
    setStatus('');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items: payload },
      dataType: 'json'
    })
      .done(function () {
        if (AFTER_ADD === 'cart') {
          window.location.href = '/cart';
          return;
        }

        setStatus(TEXTS.success, false);
        $(document).trigger('cart:refresh');
        $button.prop('disabled', false).removeClass('is-loading').text(originalLabel);
      })
      .fail(function (xhr) {
        var message = TEXTS.error;

        if (xhr && xhr.responseJSON && xhr.responseJSON.description) {
          message = xhr.responseJSON.description;
        }

        setStatus(message, true);
        $button.prop('disabled', false).removeClass('is-loading').text(originalLabel);
      });
  });
})(jQuery);
